import React from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import Cancel from './../../../../../assets/icons/close.png'
import itemImg from './../../../../../assets/icons/inventory.png'
import scheduleImg from './../../../../../assets/icons/schedule.png'
import binImg from './../../../../../assets/icons/recycle-binColor.png'
import TextAreaComponents from '../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import SchedulerComponent from '../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx';
import AutoCompleteMultiSelect from '../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import AddItemDialogComponent from '../../AddItemDialog.tsx';
import CustomDataGrid from '../../../../components/CustomDataGrid/CustomDataGrid.tsx';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import './InventoryDialog.css'
import InventoryScheduleDialog from './InventoryScheduleDialog/InventoryScheduleDialog.tsx';


function InventoryDialog(props) {
    const handleClose = () => {
        props.onClose(false)
    }
    const [quantity, setquantity] = React.useState();
    const textFieldValue = (props) => {
        console.log(props)
        setquantity(props)
    }
    const itemdata = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const [item, setItem] = React.useState();
    const addValue = (props) => {
        console.log(props)
        setItem(props)
    }
    const [open, setOpen] = React.useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleAddItem = (AddItemData) => {
        setOpen(AddItemData)
    }

    const [scheduleopen, setScheduleOpen] = React.useState(false)
    const handleClickScheduleOpen = () => {
        setScheduleOpen(true)
    }
    const handleAddSchedule = (props) => {
        console.log("props: " + props);
        setScheduleOpen(false);

        var data = dataRows;

        selectedDataRows.map((d, index) => {
            console.log("Data: " + d.item);
            var l = data.find(x => x.id == d.id);
            var i = data.indexOf(l);
            data[i].schedule = props;
        })
        settempDatarows(data);
        setDatarows([]);
    }


    const columns = [

        { field: 'item', headerName: 'Item', flex: 1 },
        { field: 'quantity', headerName: 'Quantity', flex: 1 },
        { field: 'schedule', headerName: 'Schedule', flex: 1 }
    ];

    const [selectedDataRows, setSelectedDatarows] = React.useState([]);
    const getselectedData = (props) => {
        console.log("props: " + props);
        setSelectedDatarows(props);
    }


    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 320,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));


    const [dataRows, setDatarows] = React.useState([]);
    const [tempdataRows, settempDatarows] = React.useState([]);


    React.useEffect(() => {
        setDatarows(tempdataRows);
    }, [dataRows])

    const addData = () => {

        var data = dataRows;

        var obj = {
            id: data.length,
            item: item,
            quantity: quantity,
            schedule: "No schedule"
        }
        data.push(obj);
        settempDatarows(data);
        setDatarows([]);
        console.log("dataRows: " + dataRows);
    }
    const handleClickRemoveOpen = () => {
        var data = dataRows;

        selectedDataRows.map((d, index) => {
            console.log("Data: " + d.item);
            var l = data.find(x => x.id == d.id);
            var i = data.indexOf(l);
            data = data.slice(i, 1);
        })
        settempDatarows(data);
        setDatarows([]);
    }

    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>GoTaste :-  Setup Inventory</span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Item
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Item Name"}
                                    placeholder={'Item Name'}
                                    value={addValue}
                                    datas={itemdata}
                                    id={1}
                                />
                            </Grid>
                            <Grid item xs={1} style={{ paddingTop: '1rem' }}>
                                <button className='modalAddButton' onClick={() => { handleClickOpen() }}>+Add Item</button>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Quantity
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Quantity'} value={textFieldValue} id={2} />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <div className='d-flex justify-content-center'>
                                    <button className='btn btn-success' onClick={() => { addData() }}>Add</button>
                                </div>

                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} style={{ paddingTop: '1rem' }}>
                                <div className='d-flex'>
                                    <div>
                                        <div className={`${selectedDataRows.length === 0 ? "" : "d-none"}`}
                                            style={{ filter: "contrast(.5)", }}>
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit">Please Select Items From The Table</Typography>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button>
                                                    <div className='d-flex ' style={{ gap: "10px" }}>
                                                        <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                            <img src={scheduleImg} alt='' style={{ width: "1.2rem" }} />
                                                            Apply schedule
                                                        </div>

                                                    </div>
                                                </Button>

                                            </HtmlTooltip>
                                        </div>

                                        <div className={`${selectedDataRows.length > 0 ? "" : "d-none"}`}>
                                            <Button onClick={() => { handleClickScheduleOpen() }}>
                                                <div className='d-flex ' style={{ gap: "10px" }}>
                                                    <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                        <img src={scheduleImg} alt='' style={{ width: "1.2rem" }} />
                                                        Apply schedule
                                                    </div>

                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={`${selectedDataRows.length === 0 ? "" : "d-none"}`}
                                            style={{ filter: "contrast(.5)", }}>
                                            <HtmlTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit">Please Select Items From The Table</Typography>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button>
                                                    <div className='d-flex ' style={{ gap: "10px" }}>
                                                        <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                            <img src={binImg} alt='' style={{ width: "1.2rem" }} />

                                                        </div>

                                                    </div>
                                                </Button>

                                            </HtmlTooltip>
                                        </div>

                                        <div className={`${selectedDataRows.length > 0 ? "" : "d-none"}`}>
                                            <Button onClick={() => { handleClickRemoveOpen() }}>
                                                <div className='d-flex ' style={{ gap: "10px" }}>
                                                    <div className='roundedCorner' style={{ cursor: "pointer" }}>
                                                        <img src={binImg} alt='' style={{ width: "1.2rem" }} />
                                                    </div>

                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                </div>


                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12} style={{ paddingTop: '1rem' }}>
                                <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData} />
                            </Grid>
                        </Grid>


                        {/* <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Available Time
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                
                                <SchedulerComponent></SchedulerComponent>
                            </Grid>
                        </Grid> */}

                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="">Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddItemDialogComponent
                open={open}
                onHandleAddItem={handleAddItem}
                title={props.title}
            />
            <InventoryScheduleDialog
                open={scheduleopen}
                onHandleAddItem={handleAddSchedule}
                title={props.title}
            />
        </div>
    );
}

export default InventoryDialog;